var _path, _path2, _path3, _path4, _path5, _g, _g2, _circle, _path6, _g3, _path7, _circle2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkguideFeaturesUnderstanding300X300(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.4 67v201.73a5 5 0 01-5 5H22.1a5 5 0 01-5-5V29a5 5 0 015-5h216.69z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.11 255.13l-137-.39c-2 0-10.75-6.87-10.71-15.35s7.3-15.34 9.32-15.33l138.38.65c2 0 9.43 6.54 9.39 15s-7.36 15.43-9.38 15.42z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.4 270.9a.5.5 0 01-.5-.5V67.51a.5.5 0 01.5-.5.5.5 0 01.5.5V270.4a.5.5 0 01-.5.5zM17.6 270.9a.5.5 0 01-.5-.5V30.46A5.5 5.5 0 0122.6 25h216.19a.5.5 0 01.5.5.5.5 0 01-.5.5H22.6a4.5 4.5 0 00-4.5 4.5v239.9a.5.5 0 01-.5.5z",
    fill: "#4355b9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.4 67.51h-38.61a5 5 0 01-5-5v-37z",
    fill: "#dee0ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.4 68h-38.61a5.51 5.51 0 01-5.5-5.5v-37a.51.51 0 01.3-.46.53.53 0 01.55.1l43.61 42.05a.49.49 0 01.12.54.51.51 0 01-.47.27zm-43.11-41.36v35.87a4.51 4.51 0 004.5 4.5h37.37zM277.4 275.9h-.14a.5.5 0 010-1h.14a4.5 4.5 0 004.5-4.5.5.5 0 01.5-.5.5.5 0 01.5.5 5.5 5.5 0 01-5.5 5.5zm-8.14 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 010-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 110-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 110-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 110-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 110-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 110-1h8a.5.5 0 010 1zm-16 0h-8a.5.5 0 110-1h8a.5.5 0 010 1zm-16 0H22.6a5.39 5.39 0 01-1.45-.19.51.51 0 01-.36-.62.52.52 0 01.62-.35 4.27 4.27 0 001.19.16h6.66a.5.5 0 010 1z",
    fill: "#4355b9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd9e2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.93,
    cy: 82.47,
    r: 8.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4 89H91.72a6.5 6.5 0 010-13H237.4a6.5 6.5 0 010 13z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4355b9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.93,
    cy: 125.07,
    r: 8.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4 131.57H91.72a6.5 6.5 0 010-13H237.4a6.5 6.5 0 110 13z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.96,
    cy: 238.32,
    r: 16.81,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.83 225.06a.5.5 0 01-.46-.3.51.51 0 01.26-.66l7.37-3.2a.5.5 0 11.4.92L74 225a.71.71 0 01-.17.06zm146.14 0a.59.59 0 01-.22-.05l-.51-.24a.5.5 0 01.43-.91l.51.25a.49.49 0 01.24.66.51.51 0 01-.42.29zm-7.74-3.68a.44.44 0 01-.22 0l-7.22-3.43a.49.49 0 01-.24-.66.5.5 0 01.67-.24l7.22 3.43a.5.5 0 01.24.67.48.48 0 01-.45.23zm-123.74-2.72a.49.49 0 01-.45-.3.5.5 0 01.25-.66l7.34-3.2a.5.5 0 01.65.26.5.5 0 01-.25.66l-7.34 3.2a.45.45 0 01-.2.04zm109.29-4.14a.54.54 0 01-.22-.05l-7.22-3.47a.5.5 0 01-.24-.67.5.5 0 01.66-.24l7.23 3.44a.49.49 0 01.24.66.51.51 0 01-.45.33zm-94.62-2.26a.5.5 0 01-.2-1l7.33-3.2a.5.5 0 11.4.92l-7.33 3.2a.51.51 0 01-.2.08zm80.16-4.61a.41.41 0 01-.21-.05l-7.23-3.43a.5.5 0 01-.23-.67.49.49 0 01.66-.23l7.23 3.43a.5.5 0 01-.22 1zm-65.5-1.79a.5.5 0 01-.2-1l7.34-3.2a.5.5 0 01.65.26.5.5 0 01-.25.66l-7.34 3.2a.45.45 0 01-.2.08zm51.05-5.07a.54.54 0 01-.21 0l-7.23-3.43a.51.51 0 01-.24-.67.5.5 0 01.67-.24l7.23 3.44a.49.49 0 01.23.66.49.49 0 01-.45.24zm-36.38-1.33a.5.5 0 01-.46-.3.49.49 0 01.26-.65l7.33-3.2a.5.5 0 11.4.91l-7.33 3.2a.48.48 0 01-.2.04zm21.93-5.54a.38.38 0 01-.21 0l-4.22-2-2.64 1.08a.5.5 0 01-.66-.26.5.5 0 01.26-.65l3.06-1.34 4.63 2.2a.51.51 0 01.23.67.48.48 0 01-.45.3z",
    fill: "#b90063"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 182.27,
    r: 16.81,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2 184.12a7.2 7.2 0 01-14.4 0c0-4 4.53-6.83 7.2-10.9 2.73 3.99 7.2 6.93 7.2 10.9z",
    fill: "#4355b9"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150 166a.5.5 0 01-.5-.5v-7.9a.5.5 0 011 0v7.86a.5.5 0 01-.5.54zm0-15.86a.5.5 0 01-.5-.5v-8a.5.5 0 011 0v8a.5.5 0 01-.5.46z",
    fill: "#b90063"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.96,
    cy: 238.32,
    r: 7.2,
    fill: "none",
    stroke: "#4355b9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248 232.82a5.52 5.52 0 010 11H118.05a5.52 5.52 0 010-11H248m0-1H118.05a6.52 6.52 0 000 13H248a6.52 6.52 0 000-13z",
    fill: "#4355b9"
  })));
}
export default SvgWorkguideFeaturesUnderstanding300X300;